import OperatorFairnessModuleHelper from "../../../Components/Info/Fairness/Index";

const OperatorFairnessModulePage = () => {
  return <OperatorFairnessModuleHelper />;
};

export default OperatorFairnessModulePage;
